<template>
  <div>

    <div class="mobile">
      <v-container grid-list-md>
        <v-layout row wrap>
          <template v-for="cat in drinkCategories">
            <v-flex xs12 md6 lg4 :key="cat.id">
              <CategoryCard class="pointer" @click.native.passive="gotoCategory(cat)"
                            :category="cat"></CategoryCard>
            </v-flex>
          </template>
          <template v-if="showAlternative && drinkCategories.length === 0">
            <v-flex xs12>
              <div class="text-center">
                <h3>Die Getränkekarte ist zur Zeit deaktiviert</h3>
                <div>Versuche es zu einem späteren Zeitpunkt erneut</div>
                <div class="spacer-25"></div>
                <MyLieferzeiten v-if="$store.getters.deliveryOrderingEnabled"></MyLieferzeiten>
                <MyAbholzeiten v-if="$store.getters.takeawayOrderingEnabled"></MyAbholzeiten>
              </div>
            </v-flex>
          </template>
          <!--                    <v-flex xs12 md6 lg4 v-if="lastGotoFoods">-->
          <!--                        <GotoFoodsCard class="pointer" @click.native.passive="gotoFoods"-->
          <!--                        ></GotoFoodsCard>-->
          <!--                    </v-flex>-->
        </v-layout>
      </v-container>
    </div>

    <div class="tablet">
      <v-container grid-list-lg>
        <v-layout row wrap>
          <template v-for="cat in drinkCategories">
            <v-flex xs12 md6 lg4 :key="cat.id">
              <CategoryCard class="pointer" @click.native.passive="gotoCategory(cat)"
                            :category="cat"></CategoryCard>
            </v-flex>
          </template>
          <template v-if="showAlternative && drinkCategories.length === 0">
            <v-flex xs12>
              <div class="text-center">
                <h3>Die Getränkekarte ist zur Zeit deaktiviert</h3>
                <div>Versuche es zu einem späteren Zeitpunkt erneut</div>
                <div class="spacer-25"></div>
                <MyLieferzeiten v-if="$store.getters.deliveryOrderingEnabled"></MyLieferzeiten>
                <MyAbholzeiten v-if="$store.getters.takeawayOrderingEnabled"></MyAbholzeiten>
              </div>
            </v-flex>
          </template>
          <!--                    <v-flex xs12 md6 lg4 v-if="lastGotoFoods">-->
          <!--                        <GotoFoodsCard class="pointer" @click.native.passive="gotoFoods"-->
          <!--                        ></GotoFoodsCard>-->
          <!--                    </v-flex>-->
        </v-layout>
      </v-container>
    </div>


  </div>
</template>

<script>
import store from '../store/store'
import {ebus} from '../vendor/ebus';
import * as qconst from '../vendor/qconstants';
import * as util from '../vendor/util'
// import {offerMixin} from "../mixins/offerMixin";
import CategoryCard from "../components/CategoryCard";
import MyLieferzeiten from "@/components/MyLieferzeiten.vue";
import MyAbholzeiten from "@/components/MyAbholzeiten.vue";
// import GotoFoodsCard from "./GotoFoodsCard";

export default {
  name: "DrinkCards",
  components: {
    MyAbholzeiten,
    MyLieferzeiten,
    CategoryCard
  },
  // mixins: [offerMixin],
  props: {
    showAlternative: {
      default: false,
      type: Boolean
    },
    lastGotoFoods: {
      default: false,
      type: Boolean
    },
  },
  data() {
    return {
      // drinkCategories: [],
    }
  },
  computed: {
    drinkCategories() {
      let list = store.getters.drinkMenu
      let catname = this.$route.params?.catname
      if (catname) {
        list = list.filter(i => i.categoryDE !== catname);
      }
      return list;
    },
  },
  created() {
    // ebus.$on('offersUpdated', () => {
    //     this.init();
    // });
    ebus.$on(qconst.notify$drinksUpdated, () => {
      this.init();
    });
  },
  destroyed() {
    util.clearEvents([
      qconst.notify$drinksUpdated,
    ]);
  },
  mounted() {
    this.init();
  },
  // activated() {
  //     this.init();
  // },
  methods: {
    init() {
      // let cats = util.cloneMe(store.getters.drinkMenu);
      // let relevant = [];
      // for (let cat of cats) {
      //   if (!cat.items) {
      //     continue;
      //   }
      //   relevant.push(cat);
      //   // for (let item of fcat.items) {
      //   //     let offerAndItem = store.getters.getOfferByItemId(item.id);
      //   //     // item.offered = !!offerAndItem;
      //   //     // if (!!offerAndItem) {
      //   //     //     item.offerId = offerAndItem.offer.id;
      //   //     // }
      //   //     this.applyOfferAndPrices(item, offerAndItem);
      //     // }
      // }
      // this.drinkCategories = relevant;
    },
    gotoCategory(cat) {
      // store.commit('selectedCategoryId', cat.id);
      if (this.$route.params.catname === cat.categoryDE) {
        util.jumpToTop();
        return;
      }
      store.state.shouldJump = true;
      if (cat.items.length === 1 && !cat.items[0].section) {
        ebus.$emit('goto', {name: 'Getraenk', params: {itemId: cat.items[0].id}, scrollTarget: ''});
        // this.gotoItem(this.productsOfCategory[0]);
      } else {
        this.$router.push({name: 'GetraenkeProdukte', params: {catname: cat.categoryDE}});
      }
    },
    gotoFoods() {
      this.$router.push({name: 'Sortiment'});
    }
  }


}
</script>

<style scoped lang="scss">

</style>
